<mat-form-field style="width: 200px;">
  <mat-label>{{ placeholder }}</mat-label>
  <input
    #inputElement
    matInput
    [placeholder]="placeholder"
    [formControl]="formControl"
    [matAutocomplete]="inputauto"
    (blur)="validateSelection()"
    [required]="isrequired"
  />
  <!-- Autocomplete dropdown with virtual scroll -->
  <mat-autocomplete #inputauto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)" class="custom-autocomplete-pane">
    <cdk-virtual-scroll-viewport itemSize="50" class="options-viewport">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ option }}
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-autocomplete>

  <!-- Validation message -->
  <mat-error *ngIf="formControl?.hasError('') && formControl?.touched">
    {{ placeholder }} is required.
  </mat-error>
</mat-form-field>
